import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";

import Sentry from "@similarweb/sentry-logger";

import { allTrackers } from "app/services/track/track";

import type { IPackagesPrice } from "../types";

import { TRACKING_EVENTS } from "./constants";
import { getUSDPrice } from "./getPackagesData";
import { PackageItem } from "./PackageItem/PackageItem";
import { CloseButton, Wrapper } from "./StyledComponents";

interface IStepPackagesCIAndSEOAndAdsDesktopProps {
    packages: IPackagesPrice;
    setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

export const StepPackagesCIAndSEOAndAdsDesktop = ({ packages, setIsOpen }: IStepPackagesCIAndSEOAndAdsDesktopProps) => {
    useEffect(() => {
        try {
            if (packages) {
                const {
                    CompetitiveIntelligenceAnnually,
                    CompetitiveIntelligenceSEOAnnually,
                    ADsCompetitiveIntelligenceSEOAEOAnnually,
                } = packages;
                const priceStrings = [
                    `CompetitiveIntelligence: ${getUSDPrice(CompetitiveIntelligenceAnnually)}`,
                    `CompetitiveIntelligenceSEO: ${getUSDPrice(CompetitiveIntelligenceSEOAnnually)}`,
                    `ADsCompetitiveIntelligenceSEOAEO: ${getUSDPrice(ADsCompetitiveIntelligenceSEOAEOAnnually)}`,
                ];
                allTrackers.dispatchTrackEvent(
                    TRACKING_EVENTS.category,
                    TRACKING_EVENTS.actionShow,
                    priceStrings.join(", "),
                );
            }
        } catch (error) {
            Sentry.errorTracker({
                e: error,
                message: "Failed to track reactivation packages modal v2 show event",
                level: "error",
            });
        }
    }, [packages]);

    return (
        <Wrapper data-automation="reactivation-packages-v2-modal">
            <CloseButton
                iconName="clear"
                iconSize="sm"
                type="flat"
                onClick={() => setIsOpen?.(false)}
                data-automation="reactivation-packages-v2-close"
            />
            <PackageItem packages={packages} />
        </Wrapper>
    );
};
